import { TFunction } from "react-i18next"
import * as yup from "yup"
const schema = ({ t }: { t: TFunction }) => {
  return yup.object().shape({
    account: yup
      .string()
      .required(t("authentication:prompt_account"))
      .email(t("sales:order.place_order_checkout_email_incorrect_msg")),
    password: yup.string().required(t("authentication:prompt_password")),
  })
}

export default schema
